import React from 'react';
import { openNewWindow, setColumnWidth, setDash, setDetailPageUrl, setPhoneFormat } from '../../../../lib/common';
import { setDateFormat } from '../../../../lib/moment';
import { AMONDZ_MEMBER_TYPE, DATE_FORMAT } from '../../../../constants/service/common/utilConstants';
import {
  ACCOUNT_USER_DETAIL_TAB_KEY,
  ACCOUNT_USER_STATUS_TEXT,
} from '../../../../constants/service/app/accountUserConstants';
import SendMessageService from '../../../../containers/app/common/SendMessageService';
import Anchor from '../../../../components/link/Anchor';
import { ACCOUNT_USER_DETAIL_URL_PATH } from '../../../../constants/service/common/urlConstants';

/**
 *  쿠폰 리스트 컬럼
 */
const columns = (data) => {
  const { list } = data;
  return [
    {
      accessor: 'userId',
      Header: '회원번호',
      fixed: 'left',
      width: 80,
      Cell: (row) => (
        <Anchor
          color="primary"
          isUnderLine
          text={row.value}
          onClick={() =>
            openNewWindow(
              setDetailPageUrl(ACCOUNT_USER_DETAIL_URL_PATH, row.original.userId) +
                `?tabKey=${ACCOUNT_USER_DETAIL_TAB_KEY.COUPON_INFO}`,
            )
          }
        />
      ),
    },
    {
      accessor: 'userName',
      Header: '이름',
      resizable: true,
      fixed: 'left',
      width: setColumnWidth(list, 'userName'),
    },
    {
      accessor: 'cellPhone',
      Header: '휴대전화 번호',
      resizable: true,
      fixed: 'left',
      width: 170,
      Cell: (row) => (
        <SendMessageService
          text={setPhoneFormat(row.value)}
          memberType={AMONDZ_MEMBER_TYPE.USER}
          targetId={row.original.userId}
        />
      ),
    },
    {
      accessor: 'account',
      Header: '회원 ID',
      resizable: true,
      width: setColumnWidth(list, 'account'),
    },
    {
      accessor: 'status',
      Header: '상태',
      width: 170,
      Cell: (row) => ACCOUNT_USER_STATUS_TEXT[row.value] || '_',
    },
    {
      accessor: 'createDate',
      Header: '가입일자',
      width: 320,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_DASH_FORMAT),
    },
    {
      accessor: 'recentlyUsedCouponName',
      Header: '최근 사용한 쿠폰명',
      resizable: true,
      width: setColumnWidth(list, 'recentlyUsedCouponName'),
      Cell: (row) => setDash(row.value),
    },
    {
      accessor: 'recentlyUsedCouponDescription',
      Header: '최근 사용한 쿠폰 설명',
      resizable: true,
      Cell: (row) => setDash(row.value),
    },
    {
      accessor: 'recentlyUsedCouponUseDay',
      Header: '최근 사용한 쿠폰 사용 일자',
      resizable: true,
      width: 200,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_DASH_FORMAT),
    },
  ];
};

export default columns;
